export const DummyPageView = () => {
  // Note: This function is kept to prevent the app from throwing an error
};
